import React from "react";
import { ContactInfo } from "../../types";

interface SubChannelSelectorProps {
  contactInfo: ContactInfo;
  setContactInfo: React.Dispatch<React.SetStateAction<ContactInfo>>;
  agentType: string | null;
}

export const SubChannelSelector: React.FC<SubChannelSelectorProps> = ({
  contactInfo,
  setContactInfo,
  agentType
}) => {
  // Only show for TPMO agent type and when phone is selected
  if (agentType !== 'TPMO' || !contactInfo.phone) {
    return null;
  }

  const handleSubChannelChange = (value: string) => {
    setContactInfo(prev => ({
      ...prev,
      subChannel: value
    }));
  };

  return (
    <div className="space-y-3 p-4 border border-border rounded-lg bg-muted/30">
      <label className="text-sm font-medium text-foreground block">
        Sub Channel <span className="text-destructive">*</span>
      </label>
      
      <div className="space-y-3">
        <div className="flex items-center space-x-3">
          <input
            type="radio"
            id="subchannel-im"
            name="subChannel"
            value="IM"
            checked={contactInfo.subChannel === 'IM'}
            onChange={(e) => handleSubChannelChange(e.target.value)}
            className="h-4 w-4 text-primary border-2 border-border focus:ring-primary focus:ring-2 focus:ring-offset-2"
          />
          <label 
            htmlFor="subchannel-im" 
            className="text-sm text-foreground cursor-pointer font-medium"
          >
            IM
          </label>
        </div>
        
        <div className="flex items-center space-x-3">
          <input
            type="radio"
            id="subchannel-serviceoapp"
            name="subChannel"
            value="ServiceoApp"
            checked={contactInfo.subChannel === 'ServiceoApp'}
            onChange={(e) => handleSubChannelChange(e.target.value)}
            className="h-4 w-4 text-primary border-2 border-border focus:ring-primary focus:ring-2 focus:ring-offset-2"
          />
          <label 
            htmlFor="subchannel-serviceoapp" 
            className="text-sm text-foreground cursor-pointer font-medium"
          >
            ServiceoApp
          </label>
        </div>
      </div>
    </div>
  );
};